'use client';

import { usePathname } from 'next/navigation';
import { useLayoutEffect, useRef } from 'react';

/**
 * Forces scroll to top on every client-side route change.
 * Uses multiple strategies to ensure it works regardless of
 * Next.js scroll restoration or streaming behavior.
 */
export default function ScrollToTop() {
	const pathname = usePathname();
	const isFirstRender = useRef(true);

	useLayoutEffect(() => {
		// Skip initial render (page load handles its own scroll)
		if (isFirstRender.current) {
			isFirstRender.current = false;

			return;
		}

		// Immediate scroll
		window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;

		// Strategy 2: After Next.js scroll restoration (runs after rAF)
		requestAnimationFrame(() => {
			window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });

			// Strategy 3: Double rAF to run after Next.js's own rAF scroll
			requestAnimationFrame(() => {
				window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
			});
		});
	}, [pathname]);

	return null;
}
